module.exports = __webpack_public_path__ + "static/nod-model-3880f343aa33258423d3b308228f45b2.png";